import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    dialogs: [],
    messengers: [],
    messages: [],
    foundDialogs: [],
    unreadMessage: 0
  }),
  mutations: {
    SET_DIALOGS(state, dialogs) {
      state.dialogs = dialogs;
    },
    SET_FOUND_DIALOGS(state, dialogs) {
      state.foundDialogs = dialogs || [];
    },
    SET_MESSAGES(state, messages) {
      if (state.messages.length > 0) {
        // При догрузке добавляем в начало, исключая дубли
        const existingIds = new Set(state.messages.map(m => m.id));
        const newMessages = messages.filter(m => !existingIds.has(m.id));
        state.messages = [...newMessages, ...state.messages];
      } else {
        // При первой загрузке просто устанавливаем
        state.messages = messages;
      }
    },
    ADD_MESSAGE(state, msg) {
      state.messages = [...state.messages, msg];
    },
    SET_MESSENGERS(state, messengers) {
      state.messengers = messengers;
    },
    CLEAR_MESSAGES(state) {
      state.messages = [];
    },
    SET_UNREAD_MESSAGES(state, count) {
      state.unreadMessage = count;
    },
  },
  actions: {
    async fetchMessengers({ commit }) {
      const res = await apiClient('messengers.get');
      commit('SET_MESSENGERS', res.list);
    },
    async toggleMessengerStatus({ commit }, data) {
      const res = await apiClient('messengers.status', data);
      commit('SET_MESSENGERS', res.list);
    },
    async removeMessenger({ commit, rootState }, data) {
      const res = await apiClient('messengers.delete', data);
      commit('SET_MESSENGERS', res.list);
      // Отправляем в сокет команду удалить сессию WA для этого messenger_id
      if (rootState.socket?.socket && rootState.socket.connected) {
        rootState.socket.socket.emit('whatsapp-remove-session', { messenger_id: data.messengerId });
      }
    },
    async fetchDialogs({ commit }, data) {
      const res = await apiClient('dialogs.get', data);
      if(res.list.length > 0) {
        commit('SET_DIALOGS', res.list);
        // Подсчёт всех непрочитанных сообщений
        const totalUnread = res.list.reduce((acc, dialog) => {
          return acc + (dialog.unread_count || 0);
        }, 0);
        commit('SET_UNREAD_MESSAGES', totalUnread);
      }
    },
    async findDialogs({ commit }, params) {
      // params can contain: { phone, client_id, messenger_id, limit, page }
      const res = await apiClient('dialogs.find', params);
      const list = Array.isArray(res?.list) ? res.list : [];
      commit('SET_FOUND_DIALOGS', list);
      return list; // return for convenience in components
    },
    async createDialog({ dispatch }, payload) {
      await apiClient('dialogs.create', payload);
      await dispatch('fetchDialogs');
    },
    async fetchMessages({ commit }, data) {
      if (!data.page || data.page === 1) {
        commit('CLEAR_MESSAGES');
      }
      const res = await apiClient('messages.get', data);
      commit('SET_MESSAGES', res.list);
    },
    async addMessage({ commit }, dialogId) {
      const res = await apiClient('messages.create', { dialog_id: dialogId });
      commit('SET_MESSAGES', res.list);
    },
    async initiateMessengerAuth({ dispatch }, payload) {
      const res = await apiClient('messengers.initiateAuth', payload);
      await dispatch('fetchMessengers'); // обновить список после создания
      return res; // вернёт { messenger_id: 42 }
    },
    async updateMessengerAccess({ commit }, payload) {
      const res = await apiClient('messengers.roles', payload);
      commit('SET_MESSENGERS', res.list);
    },
    async markAsReadBatch({ dispatch, rootState }, payload) {
      await apiClient('messages.read', payload);

      if (rootState.socket?.socket && rootState.socket.connected) {
        const socket = rootState.socket.socket;

        if (payload.messenger_type === 'telegram') {
          socket.emit('mark-telegram-read', {
            dialog_id: payload.dialog_id,
            message_ids: payload.message_ids,
          });
        } else {
          socket.emit('mark-whatsapp-read', {
            dialog_id: payload.dialog_id,
            message_ids: payload.message_ids,
          });
        }
      }

      await dispatch('fetchDialogs');
    },
    async getActiveMessengers() {
      const res = await apiClient('messengers.active');
      return Array.isArray(res?.list) ? res.list : [];
    },
    async createDialogAction({ dispatch }, payload) {
      // Создаём диалог на бэке
      const res = await apiClient('dialogs.create', payload)

      // Бэкенд ВОЗВРАЩАЕТ СПИСОК диалогов — ищем нужный ЗДЕСЬ
      const list = Array.isArray(res?.list) ? res.list : []

      const mid = Number(payload.messenger_id ?? payload.messengerId ?? 0)
      // Поддержка обоих наименований: client_id или client_external_id
      const pidRaw = payload.client_id ?? payload.clientId ?? payload.client_external_id ?? payload.clientExternalId ?? null
      const pid = pidRaw != null ? Number(pidRaw) : null

      let createdId = null
      if (list.length) {
        const found = list.find(d =>
          (!mid || Number(d.messenger_id) === mid) &&
          (!pid || Number(d.client_id) === pid)
        )
        if (found) createdId = found.id
      }

      // Обновим общий список диалогов для UI
      await dispatch('fetchDialogs')

      // Вернём id созданного диалога для навигации
      return createdId
    },
    async testEmailConnection(_, data) {
       return await apiClient('messengers.email_ping', data);
    },
    async addMessenger({commit}, data) {
      const res =  await apiClient('messengers.create', data);
      if(res?.list){
        commit('SET_MESSENGERS', res.list);
      }
      return res;
    },
  },
}
